/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'news': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M867.2 160H160c-54.4 0-96 44.8-96 96v512c0 54.4 41.6 96 96 96h707.2c54.4 0 96-41.6 96-96V256c0-51.2-41.6-96-96-96zm32 608c0 19.2-12.8 32-32 32H160c-19.2 0-32-12.8-32-32V256c0-19.2 12.8-32 32-32h707.2c19.2 0 32 12.8 32 32v512z"/><path pid="1" d="M227.2 544H416c19.2 0 32-12.8 32-32V323.2c0-19.2-12.8-32-32-32H227.2c-19.2 0-32 12.8-32 32V512c0 19.2 12.8 32 32 32zm32-188.8H384V480H259.2V355.2zM800 288H544c-19.2 0-32 12.8-32 32s12.8 32 32 32h256c19.2 0 32-12.8 32-32s-12.8-32-32-32zM672 480c19.2 0 32-12.8 32-32s-12.8-32-32-32H544c-19.2 0-32 12.8-32 32s12.8 32 32 32h128zM800 672H224c-19.2 0-32 12.8-32 32s12.8 32 32 32h576c19.2 0 32-12.8 32-32s-12.8-32-32-32z"/>'
  }
})
